module.exports = __webpack_public_path__ + "img/upload-01.31cd984b.svg";